import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import gitHubIcon from '../../../../../assets/images/github/github-black.svg';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupBody from '../../../../components/Popup/PopupBody';
import PopupButtons from '../../../../components/Popup/PopupButtons';
import PopupButton from '../../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../../components/Popup/PopupCancelButton';
import Dialog from '../../TestMode/Dialog/Dialog';
import Node from '../../../../../classes/Node';
import store from '../../../../../store';

class MergeTestCasesForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedFileInd: 0,
            files: props.files
        };
    }

    selectFile = (index) => {
        this.setState({ selectedFileInd: index });
    }

    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    updateFileText = () => {
        const { files, selectedFileInd } = this.state;
        const newFiles = [...files];
        newFiles[selectedFileInd] = {
            ...newFiles[selectedFileInd],
            text: this.mergeView.edit.getValue()
        };
        this.setState({
            files: newFiles
        });
    }

    restartMerge = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd],
            mine: false
        };
        this.setState({
            files: newFiles
        });
    }

    mergeUsingTheirs = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd],
            resultPhrases: JSON.parse(initialFiles[selectedFileInd].remoteContent),
            mine: false
        };
        this.setState({
            files: newFiles
        });
    }
    mergeUsingMine = () => {
        const { files, selectedFileInd } = this.state;
        const { files: initialFiles } = this.props;
        const newFiles = [...files];

        newFiles[selectedFileInd] = {
            ...initialFiles[selectedFileInd],
            resultPhrases: [...initialFiles[selectedFileInd].phrases],
            mine: true
        };
        this.setState({
            files: newFiles
        });
    }

    markAsResolved = () => {
        const { files, selectedFileInd } = this.state;
        const newFiles = [...files];
        newFiles[selectedFileInd].resolved = true;
        this.setState({
            files: newFiles
        });
    }

    finishMerge = () => {
        const { finishMerge } = this.props;
        const { files } = this.state;
        finishMerge(files.filter(file => file.mine !== true));
    }

    render() {
        const { files, selectedFileInd } = this.state;
        const hasUnresolvedFiles = files.filter(file => file.resolved !== true).length > 0;
        const selectedFile = files[selectedFileInd];
        let hasRemoteDialogs = false;
        let remoteDialogIsEmpty = false;
        let hasLocalDialogs = false;
        let hasResultDialogs = false;

        let remoteDialogTree, localDialogTree, resultDialogTree,
            remoteDialogs, localDialogs, resultDialogs,
            remoteDialogsKeys, localDialogsKeys, resultDialogsKeys;


        if (_.isString(selectedFile.remoteContent) && !_.isEmpty(selectedFile.remoteContent)) {
            remoteDialogIsEmpty = selectedFile.remoteContent.trim() === '[]';
            hasRemoteDialogs = true;
            remoteDialogTree = new Node().getTree(JSON.parse(selectedFile.remoteContent));
            remoteDialogs = remoteDialogTree.toDialogs({}, 0);
            remoteDialogsKeys = remoteDialogs ? Object.keys(remoteDialogs) : [];
        }
        if (_.isArray(selectedFile.phrases)) {
            hasLocalDialogs = true;
            localDialogTree = new Node().getTree(selectedFile.phrases);
            localDialogs = localDialogTree.toDialogs({}, 0);
            localDialogsKeys = localDialogs ? Object.keys(localDialogs) : [];
        }

        if (_.isArray(selectedFile.resultPhrases)) {
            hasResultDialogs = true;
            resultDialogTree = new Node().getTree(selectedFile.resultPhrases);
            resultDialogs = resultDialogTree.toDialogs({}, 0);
            resultDialogsKeys = resultDialogs ? Object.keys(resultDialogs) : [];
        }

        return <PopupWrapper className="merge-test-cases-form" >
            <PopupHeader
                title="Resolve Conflicts"
                titleIconImg={gitHubIcon}
                onCancel={this.cancel}
            />
            <PopupBody>
                <div className="merge-test-cases-form__body">
                    <div className="merge-test-cases-form__body-info">
                        Resolve all conflicts to be able to finish merge
                    </div>

                    <div className="merge-test-cases-form__file-panel">
                        <div className="merge-test-cases-form__file-panel-title">
                            Files:
                        </div>
                        <div className="merge-test-cases-form__file-panel-list">
                            {files.map(({ name, resolved }, index) => {
                                return <div
                                    key={name}
                                    className={`merge-test-cases-form__file ${index === selectedFileInd && 'selected'}`}
                                    onClick={() => { this.selectFile(index); }}>
                                    {resolved ?
                                        <i className="icon icon-alan-circle-ok" /> :
                                        <i className="icon icon-alan-alert" />}
                                    {name}
                                </div>;
                            })}
                        </div>
                    </div>
                    <div className="merge-test-cases-form__merge-panel">
                        <div className="merge-test-cases-form__merge-panel-title">
                            <div>Remote version</div>
                            <div>Final version</div>
                            <div>Project's version</div>
                        </div>
                        <div className="merge-test-cases-form__merge-view">
                            <div className="merge-test-cases-form__merge-view-remote">
                                {hasRemoteDialogs ? (!remoteDialogIsEmpty ? remoteDialogsKeys?.map((key, index) => {
                                    const dialog = remoteDialogs[key];
                                    return <div key={key}>
                                        <Dialog
                                            dialogTree={remoteDialogTree}
                                            dialog={dialog}
                                            index={index} />
                                    </div>;
                                }): 'Dialog is empty') : 'No data'}
                            </div>
                            <div className="merge-test-cases-form__merge-view-result">
                                {hasResultDialogs ? (selectedFile.resultPhrases.length > 0 ? resultDialogsKeys?.map((key, index) => {
                                    const dialog = resultDialogs[key];
                                    return <div key={key}>
                                        <Dialog
                                            dialogTree={resultDialogTree}
                                            dialog={dialog}
                                            index={index} />
                                    </div>;
                                }) : 'Dialog is empty') : 'No data'}
                            </div>
                            <div className="merge-test-cases-form__merge-view-local">
                                {hasLocalDialogs ? (selectedFile.phrases?.length > 0 ? localDialogsKeys?.map((key, index) => {
                                    const dialog = localDialogs[key];
                                    return <div key={key}>
                                        <Dialog
                                            dialogTree={localDialogTree}
                                            dialog={dialog}
                                            index={index} />
                                    </div>;
                                }) : 'Dialog is empty') : 'No data'}
                            </div>
                        </div>
                        <div className="merge-test-cases-form__merge-panel-btns">
                            <div
                                className="action-btn light-red-with-border restart-merge-btn"
                                onClick={this.restartMerge}>
                                Restart merge
                            </div>
                            <div className="merge-group">
                                <div
                                    className={`action-btn light-blue-with-border resolved-with-theirs-btn ${!hasRemoteDialogs && 'disabled'}`}
                                    onClick={this.mergeUsingTheirs}>
                                    Leave theirs
                                </div>
                                <div
                                    className="action-btn light-blue-with-border resolved-with-mine-btn"
                                    onClick={this.mergeUsingMine}>
                                    Leave mine
                                </div>
                            </div>

                            <div
                                className={`action-btn light-blue-with-border mark-as-resolved-btn ${!_.isArray(selectedFile.resultPhrases) && 'disabled'}`}
                                onClick={this.markAsResolved}>
                                Mark as resolved
                            </div>
                        </div>
                    </div>
                </div>
                <PopupButtons>
                    <PopupCancelButton label="Close" action={this.cancel} />
                    <PopupButton
                        className={`${hasUnresolvedFiles && 'disabled'}`}
                        label="Finish merge"
                        action={this.finishMerge} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>;
    }
}



function mapStateToProps({ testMode, projectsInfo }) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(MergeTestCasesForm));
